"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoanManager = void 0;
const tslib_1 = require("tslib");
const ImpactProvider_1 = require("./ImpactProvider");
const contracts_1 = require("./contracts");
const internalUseTransaction_1 = require("./internalUseTransaction");
const toNumber_1 = require("./toNumber");
const toToken_1 = require("./toToken");
const react_1 = tslib_1.__importStar(require("react"));
const useLoanManager = () => {
    const { provider, address, signer, networkId } = react_1.default.useContext(ImpactProvider_1.ImpactProviderContext);
    const executeTransaction = (0, internalUseTransaction_1.internalUseTransaction)();
    const [isReady, setIsReady] = react_1.default.useState(false);
    const [managerDetails, setManagerDetails] = react_1.default.useState({
        currentLentAmount: 0,
        currentLentAmountLimit: 0
    });
    (0, react_1.useEffect)(() => {
        const getManagerDetails = async () => {
            if (!address) {
                return;
            }
            const { microCredit } = (0, contracts_1.getContracts)(provider, networkId);
            const { currentLentAmount, currentLentAmountLimit } = await microCredit.managers(address);
            setManagerDetails({
                currentLentAmount: (0, toNumber_1.toNumber)(currentLentAmount),
                currentLentAmountLimit: (0, toNumber_1.toNumber)(currentLentAmountLimit)
            });
            setIsReady(true);
        };
        getManagerDetails();
    }, [address]);
    /**
     * Add loans
     * @param {object[]} loans loans to add
     * @returns {Promise<TransactionReceipt>} tx details
     */
    const addLoans = async (loans) => {
        if (!address || !signer) {
            throw new Error('No wallet connected');
        }
        const userAddresses = loans.map(loan => loan.userAddress);
        const amounts = loans.map(loan => loan.amount);
        const periods = loans.map(loan => loan.period);
        const dailyInterests = loans.map(loan => loan.dailyInterest);
        const claimDeadlines = loans.map(loan => loan.claimDeadline);
        const { microCredit } = (0, contracts_1.getContracts)(provider, networkId);
        const tx = await microCredit.populateTransaction.addLoans(userAddresses, amounts.map(amount => (0, toToken_1.toToken)(amount)), periods, dailyInterests.map(interest => (0, toToken_1.toToken)(interest)), claimDeadlines);
        const response = await executeTransaction(tx);
        return response;
    };
    /**
     * Cancel loans
     * @param {string[]} userAddresses addresses to cancel loans
     * @param {number[]} loansIds ids of each loan
     * @returns {Promise<TransactionReceipt>} tx details
     */
    const cancelLoans = async (userAddresses, loansIds) => {
        if (!address || !signer) {
            throw new Error('No wallet connected');
        }
        const { microCredit } = (0, contracts_1.getContracts)(provider, networkId);
        const tx = await microCredit.populateTransaction.cancelLoans(userAddresses, loansIds);
        const response = await executeTransaction(tx);
        return response;
    };
    /**
     * Change user address
     * @param {string} oldWalletAddress old wallet address
     * @param {string} newWalletAddress new wallet address
     * @returns {Promise<TransactionReceipt>} tx details
     */
    const changeUserAddress = async (oldWalletAddress, newWalletAddress) => {
        if (!address || !signer) {
            throw new Error('No wallet connected');
        }
        const { microCredit } = (0, contracts_1.getContracts)(provider, networkId);
        const tx = await microCredit.populateTransaction.changeUserAddress(oldWalletAddress, newWalletAddress);
        const response = await executeTransaction(tx);
        return response;
    };
    return { addLoans, cancelLoans, changeUserAddress, isReady, managerDetails };
};
exports.useLoanManager = useLoanManager;
//# sourceMappingURL=useLoanManager.js.map